var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./CommonSidebar.jinja');
require('./CommonSidebar.less');

var CommonSidebarText = require('front/components/CommonSidebar/CommonSidebarText');
var CommonSidebarImage = require('front/components/CommonSidebar/CommonSidebarImage');
var CommonSidebarDocument = require('front/components/CommonSidebar/CommonSidebarDocument');
var CommonSidebarIssue = require('front/components/CommonSidebar/CommonSidebarIssue');

module.exports = Base.extend({

    template: template,

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'CommonSidebarText': {selector: '.CommonSidebarText', viewConstructor: CommonSidebarText},
        'CommonSidebarImage': {selector: '.CommonSidebarImage', viewConstructor: CommonSidebarImage},
        'CommonSidebarDocument': {selector: '.CommonSidebarDocument', viewConstructor: CommonSidebarDocument},
        'CommonSidebarIssue': {selector: '.CommonSidebarIssue', viewConstructor: CommonSidebarIssue}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'onResize');

        var maxTop = -99999;
        this.$lastBlock = undefined;

        this.$('.CommonSidebarBlock').each(function (ind, item) {
            var top = $(item).attr('data-top') - 0;
            $(item)
                .css('top', (app.settings.isIE || app.settings.isEdge) ? top : top / window.app.settings.baseFontSize + 'rem')
                .find('.CommonSidebarBlock-wrapper')
                .show();

            if (top > maxTop) {
                maxTop = top;
                this.$lastBlock = $(item);
            }
        }.bind(this));

        Base.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        Base.prototype.viewsRegistration.call(this);

        $(window).on('resize', this.onResize);

        this.onResize();
    },


    deactivate: function (params) {
        $(window).off('resize', this.onResize);

        return Base.prototype.destroy.call(this, params);
    },


    onResize: function () {
        if (!this.$lastBlock) return;

        var minHeight = this.$lastBlock.position().top + this.$lastBlock.height();

        //if story is shorter than sidebar
        this.$el.parent().css('min-height', window.app.isPhoneLayout() ? '' : minHeight);
    }
});


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/CommonSidebar/CommonSidebar.js
// module id = 13
// module chunks = 0